const Utils = RO.classes.Utils

function noop() {}

class Countdown {
    #el
    #active
    #timer
    #remainingSeconds

    constructor({ el, onStart = noop, onTick = noop, onStop = noop }) {
        this.#el = el
        this.#active = false
        this.#timer = null
        this.#remainingSeconds = 0

        this.onStart = onStart
        this.onTick = onTick
        this.onStop = onStop

        // const initialTime = parseInt(el.dataset.roCountdownInitialTime) || 1
        // if (initialTime) {
        //     this.start(initialTime / 1000)
        // }
    }

    isActive() {
       return this.#active
    }

    getRemainingSeconds() {
        return this.#remainingSeconds
    }

    start(seconds) {
        this.#remainingSeconds = seconds
        this.#active = true

        const self = this

        this.#timer = setInterval(function() {self.#tick()}, 1000)
        this.onStart(this.#makeResult())
    }

    stop() {
        clearInterval(this.#timer)
        this.#active = false
        this.onStop(this.#makeResult())
    }

    #tick() {
        if (--this.#remainingSeconds <= 0) {
            this.stop()
        }
        this.onTick(this.#makeResult())
    }

    #makeResult() {
        return {
            el: this.#el,
            active: this.#active,
            remainingSeconds: this.#remainingSeconds,
            formattedTime: Utils.formatSecondsToHours(this.#remainingSeconds)
        }
    }

    
}

RO.classes.Countdown = Countdown
